import { BUSINESSURL } from "helpers/constant";
import { callApi } from "Apis";
import { BUSINESS_CATEGORYURL } from "helpers/constant";
import { BUSINESS_SUBCATEGORYURL } from "helpers/constant";
import { encryptId } from "helpers/cryptography";
import { PLAIN_TEXT } from "helpers/constant";

// business list api...
export async function getBusinessListApi(data) {
  try {
    const response = await callApi({ url: BUSINESSURL.LIST, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}
// business add api...
export async function addBusinessApi(data) {
  try {
    const response = await callApi({ url: BUSINESSURL.ADD, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business edit api...
export async function getBusinessDataByIdApi(id) {
  try {
    const response = await callApi({ url: BUSINESSURL.GET(id), method: "GET" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business update api...
export async function updateBusinessDataApi(data) {
  try {
    const response = await callApi({ url: BUSINESSURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business delete api...
export async function deleteBusinessDataApi(id) {
  try {
    const response = await callApi({ url: BUSINESSURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business categories api...
export async function getBusinesscategoriesApi(data) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.LIST, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business subcategories api...
export async function getBusinessSubcategoriesApi(data) {
  try {
    const response = await callApi({
      url: BUSINESS_SUBCATEGORYURL.LIST,
      body: data,
      method: "POST",
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// business verify api...
export async function verifyBusinessDataApi(id) {
  try {
    const encryptedId = PLAIN_TEXT ? id : encryptId(id);
    const response = await callApi({ url: BUSINESSURL.VERIFY(encryptedId), method: "PUT" });
    return response;
  } catch (error) {
    throw error;
  }
}
